export const FADE = 'fade';
export const SCALE_FOLD = 'scale-fold';